import {ElMessage} from "element-plus";
import {ElLoading} from 'element-plus'
import {$post} from "@/utils/request";

const showToast = {
    success: (msg) => {
        ElMessage({message: msg, type: 'success'});
    },
    fail: (msg) => {
        ElMessage({message: msg, type: 'warning'});
    },
    error: (msg) => {
        ElMessage.error(msg)
    }
}

const showLoading = (msg) => {
    return ElLoading.service({
        fullscreen: true,
        background: '#ffffff00',
        text: msg
    })
}

const newGuid = () => {
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        let r = Math.random() * 16 | 0,
            v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}

/**
 * 阿里OSS文件上传
 */
const multipartUpload = async (storage, name, file, callback = null) => {
    if (!storage) return null
    try {
        const result = await storage.multipartUpload(name, file, {
            parallel: 4,
            partSize: 2 * 1024 * 1024,
            progress: function (p, cpt, res) {
                if (callback) callback(p)
            }
        });
        return result.res.statusCode == 200 ? result : null
    } catch (err) {
        return null
    }
}

/**
 * 删除阿里OSS文件
 * @param filePath
 * @returns {Promise<void>}
 */
const deleteObject = async (storage, filePath) => {
    if (!storage) return false
    try {
        const result = await storage.delete(filePath);
        return result.res.statusCode == 204;
    } catch (err) {
        return false
    }
}

const getSysSettings = (rowkey, platform = 0, mprogid = 0) => {
    return new Promise((resolve, reject) => {
        $post('/Mobile/getSysSettings', {
            platform,
            mprogid,
            rowkey
        }).then(res => {
            if (res.code == 0) {
                resolve(res.data)
            } else {
                reject(res.msg)
            }
        }).catch(err => {
            reject(err)
        })
    })
}

const getLoginStatus = (phone, platform = 0, mprogid = 0) => {
    return new Promise((resolve, reject) => {
        $post('/Mobile/getLoginStatus', {
            platform,
            mprogid,
            phone
        }).then(res => {
            if (res.code == 0) {
                resolve(res.data)
            } else {
                reject(res.msg)
            }
        }).catch(err => {
            reject(err)
        })
    })
}

const userLoginOut = (phone, platform = 0, mprogid = 0) => {
    $post('/Mobile/userLoginOut', {
        platform,
        mprogid,
        phone
    })
}

export {
    showToast,
    showLoading,
    newGuid,
    multipartUpload,
    deleteObject,
    getSysSettings,
    getLoginStatus,
    userLoginOut
};
